import linkifyHtml from "linkify-html";

/**
 * Vue 3カスタムディレクティブ: v-linkify
 *
 * HTML内のURLを自動的にリンク化します。
 * linkifyjs (linkify-html) を使用してHTMLタグを壊さずにテキスト部分のURLのみをリンク化します。
 *
 * 使用例:
 *   <div v-linkify v-html="content"></div>
 *
 * オプション:
 *   - target: リンクのtarget属性（デフォルト: "_blank"）
 *   - rel: リンクのrel属性（デフォルト: "noopener noreferrer"）
 *   - className: リンクに付与するクラス名（デフォルト: "linkified"）
 *   - validate: URL検証関数（デフォルト: https/httpのみ許可）
 */

const linkifyDirective = {
  mounted(el) {
    linkifyElement(el);
  },
  updated(el) {
    linkifyElement(el);
  }
};

function linkifyElement(el) {
  const options = {
    target: "_blank",
    rel: "noopener noreferrer",
    className: "linkified",
    validate: {
      url: (value) => /^https?:\/\//.test(value)
    }
  };

  // エレメント内のHTMLコンテンツをlinkify化
  el.innerHTML = linkifyHtml(el.innerHTML, options);
}

export default linkifyDirective;
